import React, { useState } from "react";
import "./newsletter.scss";
import { db } from "./../../Config/Config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Newsletter = () => {
  const [newsletter, setNewsLetter] = useState("");

  const Subscribe = (e) => {
    e.preventDefault();

    db.collection("subscribe_form")
      .doc("Subscribe_user")
      .set({
        Subscribe_User: newsletter,
      })
      .then(() => {
        toast.info(
          "Subscribed Successfully you will be notified about our updates",
          {
            position: "bottom-left",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          }
        );
        setNewsLetter("");
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
      });
  };
  return (
    <div className="newsletter">
      <div className="container ">
        <h4 className="text-center">Newsletter</h4>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
            <form onSubmit={Subscribe}>
              <div className="newsletter_form">
                <input
                  type="email"
                  placeholder="example@gmail.com"
                  className="form-control"
                  value={newsletter}
                  onChange={e =>setNewsLetter(e.target.value)}
                />
                <button type="submit" className="btn btn-success ">
                  Subscribe 
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
